import React from 'react';
import { Globe } from 'lucide-react';
import profileData from '../data/profileData.json';
import { GitHubIcon, LinkedInIcon, YouTubeIcon } from './SocialIcons';

const Footer = () => {
  const { personal } = profileData;
  const quickLinks = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Projects', href: '/projects' },
    { label: 'Contact', href: '/contact' },
  ];

  return (
    <footer className="bg-[#1e3a5f] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-lg font-semibold mb-4">About</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              {personal.title}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Connect</h3>
            <div className="flex space-x-4">
              <a
                href={personal.social.github}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-md hover:bg-white/20 transition-colors duration-200"
                aria-label="GitHub"
              >
                <GitHubIcon className="h-5 w-5" />
              </a>
              <a
                href={personal.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-md hover:bg-white/20 transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <LinkedInIcon className="h-5 w-5" />
              </a>
              <a
                href={personal.social.youTube}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-md hover:bg-white/20 transition-colors duration-200"
                aria-label="YouTube"
              >
                <YouTubeIcon className="h-5 w-5" />
              </a>
              <a
                href={personal.social.dockerhub}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-md hover:bg-white/20 transition-colors duration-200"
                aria-label="DockerHub"
              >
                <Globe size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-white/10 text-center text-sm text-gray-300">
          <p>&copy; {new Date().getFullYear()} {personal.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;